/**
 * Created by jax.luo on 2017/5/22.
 */
angular.module('dpw.services')
    .factory('profileBrandsUtils', ['rcBrandIds', 'ATTBrands', 'api', 'brandsForAppGallery',
        function (rcBrandIds, ATTBrands, api, brandsForAppGallery) {
            'use strict';

            var RC_US_BRAND_ID = '1210';

            var allProfileBrands = [
                {
                    id: '1210',
                    text: 'RingCentral',
                    compatibility: 'ringcentral',
                    appGalleryName: 'RingCentral',
                    slug: '',
                },
                {
                    id: '2110',
                    text: 'Alcatel Rainbow Office',
                    compatibility: 'rainbowoffice',
                    appGalleryName: 'Rainbow Office',
                    slug: 'rainbow-office',
                },
                {
                    id: '2020',
                    text: 'Atos Unify Office',
                    compatibility: 'unifyoffice',
                    appGalleryName: 'Unify Office',
                    slug: 'unify-office',
                },
                {
                    id: '3420',
                    text: 'AT&T Office@Hand',
                    compatibility: 'office@hand',
                    appGalleryName: 'AT&T Office@Hand',
                    slug: 'office-at-hand',
                },
                {
                    id: '6010',
                    text: 'Avaya Cloud Office',
                    compatibility: 'avayacloudoffice',
                    appGalleryName: 'Avaya Cloud Office',
                    slug: 'avaya-cloud-office',
                },
                {
                    id: '7710',
                    text: 'BT Cloud Work',
                    compatibility: 'btcloudwork',
                    appGalleryName: 'BT Cloud Work',
                    slug: 'bt-cloud-work',
                },
                {
                    id: '4810',
                    text: 'RingCentral for Symphony',
                    compatibility: 'ringcentralforsymphony',
                    appGalleryName: 'RingCentral for Symphony',
                    slug: 'ringcentral-for-symphony',
                },
                {
                    id: '4210',
                    text: 'RingCentral mit ecotel',
                    compatibility: 'ringcentralmitecotel',
                    appGalleryName: 'RingCentral mit ecotel',
                    slug: 'ringcentral-mit-ecotel',
                },
                {
                    id: '4610',
                    text: 'RingCentral with Eastlink',
                    compatibility: 'ringcentralwitheastlink',
                    appGalleryName: 'RingCentral with Eastlink',
                    slug: 'ringcentral-with-eastlink',
                },
                {
                    id: '2210',
                    text: 'RingCentral with Verizon',
                    compatibility: 'ringcentralwithverizon',
                    appGalleryName: 'RingCentral with Verizon',
                    slug: 'ringcentral-with-verizon',
                },
                {
                    id: '7310',
                    text: 'TELUS Business Connect',
                    compatibility: 'telusbusinessconnect',
                    appGalleryName: 'TELUS Business Connect',
                    slug: 'telus-business-connect',
                },
                {
                    id: '7010',
                    text: 'Vodafone Business UC',
                    compatibility: 'vodafonebusiness',
                    appGalleryName: 'Vodafone Business UC',
                    slug: 'vodafone-business',
                },
                {
                    id: '4710',
                    text: 'RingCentral mit 1&1 Connected Calls',
                    compatibility: 'versatel',
                    appGalleryName: 'RingCentral mit 1&1 Connected Calls',
                    slug: 'ringcentral-mit-1und1-connected-calls',
                },
                {
                    id: '2030',
                    text: 'RingCentral mit Telekom',
                    compatibility: 'telekom',
                    appGalleryName: 'RingCentral mit Telekom',
                    slug: 'ringcentral-mit-telekom',
                },
                {
                    id: '2040',
                    text: 'Unify Office by RingCentral',
                    compatibility: 'unifyofficetelekom',
                    appGalleryName: 'Unify Office by RingCentral',
                    slug: 'unifyoffice-telekom-mit-ringcentral',
                },
                {
                    id: '4910',
                    text: 'Frontier plus RingCentral',
                    compatibility: 'frontier',
                    appGalleryName: 'Frontier plus RingCentral',
                    slug: 'frontier-plus-ringcentral',
                },
                {
                    id: '2050',
                    text: 'RingCentral with Sunrise',
                    compatibility: 'sunrise',
                    appGalleryName: 'RingCentral with Sunrise',
                    slug: 'ringcentral-with-sunrise',
                },
                {
                    id: '5110',
                    text: 'Charter SMB',
                    compatibility: 'smd',
                    appGalleryName: 'Charter SMB',
                    slug: '',
                },
                {
                    id: '5210',
                    text: 'Charter Enterprise',
                    compatibility: 'enterprise',
                    appGalleryName: 'Charter Enterprise',
                    slug: '',
                },
            ].sort(function (brandA, brandB) {
                if (brandA.id === RC_US_BRAND_ID) {
                    return -1;
                }
                if (brandB.id === RC_US_BRAND_ID) {
                    return 1;
                }
                return brandA.text.localeCompare(brandB.text);
            });

            var getBrandsForFilters = function (parentBrandIds) {
                var optionAny = {id: '', text: 'Any'};
                var brandsForFilters = getAvailableParentBrands(_.cloneDeep(allProfileBrands), parentBrandIds);

                brandsForFilters.unshift(optionAny);
                brandsForFilters.forEach(function (brand) {
                    brand.enabled = false;
                    brand.value = brand.id;
                });

                return brandsForFilters;
            };

            var getBrandsForAvailableProfiles = function (appBrandIds, subBrandIds) {
                var profileBrands = getAvailableParentBrands(allProfileBrands, subBrandIds);

                if (_.isEmpty(appBrandIds)) {
                    return profileBrands;
                }

                var availableBrands = _.filter(profileBrands, function (profileBrand) {
                    if (profileBrand.id === RC_US_BRAND_ID) {
                        return containsBrand(appBrandIds, rcBrandIds);
                    }

                    if (profileBrand.id === ATTBrands.ATT) {
                        var attBrandIds = _.toArray(ATTBrands);
                        return containsBrand(appBrandIds, attBrandIds);
                    }

                    return _.includes(appBrandIds, profileBrand.id);
                });

                return availableBrands;
            };

            var isSupportedBrand = function (app, brandId) {
                return _.some(getBrandsForAvailableProfiles(app.brands), {id: brandId});
            };

            var isValidBrand = function (brandId) {
                return _.some(allProfileBrands, {id: brandId});
            };

            var fetchParentBrandIds = function () {
                return api.call(api.admin.appGallery.galleryBrand()).then(function (res) {
                    return (res.galleryBrands || []).map(function (brand) {
                        return brand.brandId;
                    });
                });
            };

            function containsBrand(appBrandIds, brand) {
                return _.some(brand, function (brandId) {
                    return _.includes(appBrandIds, brandId);
                });
            }

            function getAvailableParentBrands(allBrands, parentBrandIds) {
                return _.filter(allBrands, function (brand) {
                    return _.includes(parentBrandIds, brand.id);
                });
            }

            function getBrandNames(app, brandMap, parentBrands, isFullName) {
                var supportBrands = getSupportParentBrands(app, brandMap, parentBrands);
                var brandNameMapping = isFullName
                    ? _.reduce(allProfileBrands, function (total, current) {
                        total[current.id] = current.text;
                        return total;
                    }, {}) : brandsForAppGallery;

                return supportBrands.map(function (brand) {
                    return brandNameMapping[brand];
                }).join(', ');
            }

            function getSupportParentBrands(app, brandMap, parentBrands) {
                var appBrands = _.get(app, 'brands', []);
                if (appBrands.length > 0) {
                    var attBrandIds = _.toArray(ATTBrands);
                    var appRootBrands = _.uniq(appBrands.map(function (appBrand) {
                        var rootBrandId = brandMap[appBrand].rootBrandId;
                        if (rcBrandIds.includes(rootBrandId)) {
                            return rcBrandIds[0];
                        }
                        if (attBrandIds.includes(rootBrandId)) {
                            return ATTBrands.ATT;
                        }
                        return rootBrandId;
                    }));

                    return parentBrands.filter(function (brand) {
                        return _.includes(appRootBrands, brand);
                    });
                }
                return parentBrands;
            }

            return {
                allProfileBrands: allProfileBrands,
                brandsForFilters: getBrandsForFilters,
                isValidBrand: isValidBrand,
                isSupportedBrand: isSupportedBrand,
                getBrandById: function (id) {
                    if (id) {
                        return _.find(allProfileBrands, 'id', id);
                    }
                },
                getBrandNameById: function (id) {
                    var brand = _.find(allProfileBrands, 'id', id);
                    return _.get(brand, 'text', '');
                },
                getBrandNames: getBrandNames,
                fetchParentBrandIds: fetchParentBrandIds
            };
        }]);
